import Http from '@/http'
import axios from 'axios'
import qs from 'qs'

import request from '@/utils/request'
import * as GLOBAL from '@/utils/global_variable'

const pathBase = GLOBAL.requestAddr + 'blade-auth'
const Base = GLOBAL.requestAddrus

// 登录获取token
export function logintoken(params) {
    return request({
        url: '/blade-auth/token',
        method: 'post',
        data: qs.stringify(params),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Authorization':"Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
            'Tenant-Id':"000000",
        }
    })
}

// 注册
export function register(params) {
    return request({
        url: '/blade-user/customer/open/register',
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    })
}
// 获取手机验证码
export function smsVerificationCode(params) {
    return request({
        url: '/blade-auth/captcha/sms-verification-code',
        method: 'get',
        params: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }
    })
}
// 获取邮箱验证码
export function emailVerificationCode(params) {
    return request({
        url: '/blade-auth/captcha/email-verification-code',
        method: 'get',
        params: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        }
    })
}
// 忘记密码
export function forgetPassword(params) {
    return request({
        url: '/blade-user/open/forget-password',
        method: 'post',
        data: qs.stringify(params),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Authorization':"Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
            'Tenant-Id':"000000",
        }
    })
}



//登陆接口
export const login = function (params) {
  return Http.post('/token', params);
};
